import { useCallback, useState } from 'react';

import useIsMobileSize from 'src/hooks/useIsMobileSize';
import { DesktopLayout, WithoutHeader } from 'src/layout';
import useUserStore from 'src/stores/user';

import DescribeYourBusiness, {
    getQuestionnaireProgressState,
    IChatsAndChannelsScreenProps,
    QuestionnaireProgressState,
} from './Content';
import QuestionnaireProgressSidebar from './QuestionnaireProgressSidebar';

export default function DescribeYourBusinessScreen(props: IChatsAndChannelsScreenProps) {
    const isMobile = useIsMobileSize();
    const { onQuestionnaireProgressChange } = props;
    const isQuestionnaireBonusAwarded = useUserStore((state) => state.isLeadsmaniaQuestionnaireBonusAwarded || false);
    const [questionnaireProgress, setQuestionnaireProgress] = useState<QuestionnaireProgressState>(
        getQuestionnaireProgressState()
    );
    const handleQuestionnaireProgressChange = useCallback(
        (progress: QuestionnaireProgressState) => {
            setQuestionnaireProgress(progress);
            onQuestionnaireProgressChange?.(progress);
        },
        [onQuestionnaireProgressChange]
    );

    if (isMobile) {
        return (
            <WithoutHeader showBack>
                <DescribeYourBusiness
                    {...props}
                    onQuestionnaireProgressChange={handleQuestionnaireProgressChange}
                />
            </WithoutHeader>
        );
    }

    return (
        <DesktopLayout
            rightSidebar={
                <QuestionnaireProgressSidebar
                    progress={questionnaireProgress}
                    isAwarded={isQuestionnaireBonusAwarded}
                />
            }
        >
            <DescribeYourBusiness
                {...props}
                onQuestionnaireProgressChange={handleQuestionnaireProgressChange}
            />
        </DesktopLayout>
    );
}
